import { render, staticRenderFns } from "./ProyectoGridView.vue?vue&type=template&id=d8f973f8&scoped=true&"
import script from "./ProyectoGridView.vue?vue&type=script&lang=js&"
export * from "./ProyectoGridView.vue?vue&type=script&lang=js&"
import style0 from "./ProyectoGridView.vue?vue&type=style&index=0&id=d8f973f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8f973f8",
  null
  
)

export default component.exports